import React from "react";
import { useEffect } from "react";

function isElementInViewport(el: Element) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

const Timeline = () => {
  useEffect(() => {
    const items = document.querySelectorAll(".timeline li");

    const callbackFunc = () => {
      items.forEach((item: Element) => {
        if (isElementInViewport(item)) {
          if (!item.classList.contains("in-view")) {
            item.classList.add("in-view");
          }
        } else if (item.classList.contains("in-view")) {
          item.classList.remove("in-view");
        }
      });
    };

    // เรียกใช้งาน callbackFunc เมื่อหน้าเว็บโหลดเสร็จและเมื่อมีการ scroll
    window.addEventListener("load", callbackFunc);
    window.addEventListener("scroll", callbackFunc);

    // ยกเลิกการใช้งาน event listener เมื่อ component ถูก unmount
    return () => {
      window.removeEventListener("load", callbackFunc);
      window.removeEventListener("scroll", callbackFunc);
    };
  }, []);

  return (
    <section className="story6 gray-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 text-center ev-heading-ov_bl">
            <h1 className="fw-bolder lh-1">OUR HISTORY</h1>
            <hr />
            <hr className="line-2" />
          </div>
          <div className="col-12">
            <section className="timeline">
              <ul>
                <li>
                  <div className="timeline-inner">
                    <time>1916</time>
                    <div className="discovery">
                      <h4>ITP Inc. founded in Kyoto, Japan</h4>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>1999</time>
                    <div className="discovery">
                      <p>
                        • Ishida Taiseisha (Thailand) Co., Ltd.
                        <br />
                        established in Samrong, Thailand
                      </p>
                      <p>
                        • Mr. Motokazu Mizuno became the first president,
                        <br />
                        and Mr. Keua Sadyapongse became
                        <br />
                        the vice president
                      </p>
                      <p>
                        • Started translation and printing
                        <br />
                        business in Thailand
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2003</time>
                    <div className="discovery">
                      <h4>
                        Bangkok office set up at
                        <br />
                        "All seasons place"
                      </h4>
                    </div>
                  </div>
                </li>

                <li>
                  <div className="timeline-inner">
                    <time>2006</time>
                    <div className="discovery">
                      <p>
                        • Mr. Masahito Matsuoka became
                        <br />
                        the second president.
                      </p>
                      <p>• Vice president was Mr. Udom Thongkamsai</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2008</time>
                    <div className="discovery">
                      <p>
                        • Established Milk Run-compatible
                        <br />
                        in-house logistics center in Bang Na
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2009</time>
                    <div className="discovery">
                      <p>• Bangkok headquarters moved to Bang Na</p>
                      <p>
                        • Celebrated 10th anniversary of establishment
                        <br />
                        of Ishida Taiseisha (Thailand) Co., Ltd.
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2010</time>
                    <div className="discovery">
                      <p>• Mr.Toru Konuma became the third president.</p>
                      <p>• Vice president was Mr. Udom Thongkamsai</p>
                      <p>
                        • Acquired printing company
                        <br />
                        DAIMU (THAILAND) CO., LTD. and established
                        <br />
                        ITP Ayutthaya factory
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2011</time>
                    <div className="discovery">
                      <p>• Mr. Toshihiko Atsumi became the fourth president.</p>
                      <p>• Vice president was Mr. Udom Thongkamsai</p>
                      <p>• Marketing business and event business started</p>
                      <p>
                        • Ayutthaya factory damaged by the flood in Thailand
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2012</time>
                    <div className="discovery">
                      <p>• Moved printing factory to Pattanakarn, Bangkok</p>
                      <p>• Mr. Chavalit Puttan appointed as vice president</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2013</time>
                    <div className="discovery">
                      <h4>
                        • Established ISHIDA TAISEISHA
                        <br />
                        YAMAGATA (THAILAND) CO., LTD.
                      </h4>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2014</time>
                    <div className="discovery">
                      <h4>
                        • Established ISHIDA TAISEISHA ASIA
                        <br />
                        PACIFIC CO., LTD.
                      </h4>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2015</time>
                    <div className="discovery">
                      <p>
                        • Mobile application development and
                        <br />
                        web application development business started
                      </p>
                      <p>• Started SNS & digital marketing business</p>
                      <p>
                        • Established innovation center as the
                        <br />
                        department in charge
                      </p>
                    </div>
                  </div>
                  <div className="timeline-inner -wq">
                    <time>2015</time>
                    <div className="discovery">
                      <p>
                        • The number of fans of the Owned Media
                        <br />
                        "Madoo Japan" has exceeded 400,000
                      </p>
                      <p>
                        • Became one of Thailand's leading media
                        <br />
                        for introducing Japan
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2016</time>
                    <div className="discovery">
                      <p>
                        • ITP Inc. 100th Anniversary Ceremony
                        <br />
                        held in Bangkok
                      </p>
                      <p>
                        • Achievement of 10 million words in
                        <br />
                        translation business
                      </p>
                      <p>• RPA development business started</p>
                      <p>
                        • Established CYBER-ITP (THAILAND) CO., LTD.
                        <br />
                        as a joint venture with CYBER PRINT,
                        <br />a major local printing company
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2019</time>
                    <div className="discovery">
                      <p>
                        • ISHIDA TAISEISHA (THAILAND) CO., LTD
                        <br />
                        20th Anniversary Ceremony was held
                      </p>
                      <p>
                        • Established ITP MYANMAR CO., LTD
                        <br />
                        in Myanmar as a subsidiary
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2020</time>
                    <div className="discovery">
                      <p>• Mr. Yoshikazu Koyama becomes the fifth president.</p>
                      <p>
                        • Vice Presidents are Mr. Shimpei Miyamoto and
                        <br />
                        Mr. Chavalit Puttan
                      </p>
                      <p>• AI development business started</p>
                      <p>
                        • Launched Owned media "Prorod" and
                        <br />
                        Mobile application "NX", starting a new domestic vehicle
                        <br />
                        sales support project in Thailand
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-inner">
                    <time>2021</time>
                    <div className="discovery">
                      <p>
                        • Change company name from
                        <br />
                        Ishida Taiseisha (Thailand) Co., Ltd.
                        <br />
                        to ITP ASIA CO.,LTD.
                      </p>
                    </div>
                  </div>
                </li>

                <li>
                  <div className="timeline-inner">
                    <time>2022</time>
                    <div className="discovery">
                      <p>
                        • Start providing AI translation technology to
                        <br />
                        iTIC (Intelligent Traffic Information Center Foundation)
                        <br />
                        who develop and contribute high quality real time
                        <br />
                        traffic reports in Thai and English.
                      </p>
                    </div>
                  </div>
                </li>

                <li>
                  <div className="timeline-inner">
                    <time>2023</time>
                    <div className="discovery">
                      <p>
                        • Started Japan's sports support projects.
                        <br />
                        • Organizing the “Japan Volleyball Asia Tour In Thailand 2023”.
                        <br />
                        For the first time in history, the top team of Japan's professional volleyball league (V-League) and the champion of the Thai league gathered in Bangkok to play a friendly match to determine the Japan-Thailand club champion.
                      </p>
                    </div>
                  </div>
                </li>

              </ul>
              <div className="timeline-end">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <h1 className="timeline-footer fw-bold">
                And our journey still keeps going
              </h1>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;
